export const getConcatenatedDates = (dates: (string | null)[]) => {
  if (dates.length > 2) {
    const totalLength = dates.length - 2;
    const firstTwoDates = dates.splice(0, 2).join(',  ');
    return `${firstTwoDates} and ${totalLength} more...`;
  } else {
    return dates.join(',  ');
  }
};
